import React from "react";
import PageWrapper from "./Fax.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import FaxTable from "components/Fax/FaxTable";

const Fax = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.fax"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.fax"
          }
        ]}
      />
      <div className="user-tbl">
        <FaxTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    admin: state.auth
  };
};

export default connect(mapStateToProps, null)(Fax);
